import { render } from "./StoreUnavailableHeader.vue?vue&type=template&id=05a822f3"
import script from "./StoreUnavailableHeader.vue?vue&type=script&lang=js"
export * from "./StoreUnavailableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__